import { DataContext } from "../DataContext";
import { useContext, useMemo } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "../styles";
import { SIZE_KEY_MAP } from "../constants";

function CartProduct(props) {
  const { updateQuantityFromCart, deleteFromCart } = useContext(DataContext);

  const { productCost, itemId, quantity, size, productName, design, inventory, thumbnail } = props.product;

  const availableStock = useMemo(() => {
    if (!inventory || !size) return 0;

    const inventoryKey = SIZE_KEY_MAP[size];
    if (!inventoryKey) return 0;

    return Number(inventory?.[inventoryKey] || 0);
  }, [inventory, size]);

  const quantityOptions = useMemo(() => {
    if (availableStock <= 0) return [];
    return Array.from({ length: Math.min(availableStock, 5) }, (_, i) => i + 1);
  }, [availableStock]);

  return (
    <div className="product-row">
      <div className="product-image">
        <picture>
          <source srcSet={thumbnail} type="image/avif" />
          <img src={thumbnail} width="140" />
        </picture>
      </div>

      <div className="product-block">
        <h2>{productName}</h2>

        <div className="product-block-row">
          <span className="product-block-label">Color</span>
          <strong className="product-block-value">{design}</strong>
        </div>

        <div className="product-block-row">
          <span className="product-block-label">Size</span>
          <strong className="product-block-value">{size}</strong>
        </div>

        <div className="product-block-row">
          <span className="product-block-label">Price</span>
          <strong className="product-block-value">${productCost / 100}</strong>
        </div>

        <div className="cartQuantity">
          <select
            name="quantity"
            id="quantity"
            className="quantity product-quantity-select"
            value={availableStock > 0 ? Math.min(quantity, availableStock) : ""}
            onChange={(e) => updateQuantityFromCart(itemId, Number(e.target.value))}
            aria-label="quantity"
            disabled={availableStock === 0}
          >
            {availableStock === 0 ? (
              <option value="">0</option>
            ) : (
              quantityOptions.map((qty) => (
                <option key={qty} value={qty}>
                  {qty}
                </option>
              ))
            )}
          </select>

          {availableStock === 0 ? (
            <div className="stock-note out-of-stock">Out of stock</div>
          ) : availableStock < 10 ? (
            <div className="stock-note">Only {availableStock} left</div>
          ) : null}

          <Button className="textWithIcon" onClick={() => deleteFromCart(itemId)}>
            <i className="fa-solid fa-xmark"></i> remove
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CartProduct;
